export const icons = [
    'black_hatchback.png',
    'black_police.png',
    'black_sedan.png',
    'blue_elegant-car.png',
    'blue_police.png',
    'blue_tanker.png',
    'green_truck.png',
    'new_black_car.png',
    'new_blue_car.png',
    'new_grey_car.png',
    'new_white_car.png',
    'pure_black_car.png',
    'pure_white_car.png',
    'red_innova.png',
    'red_sedan_car.png',
    'white_ambulance.png',
    'white_cab.png',
    'white_elegant_car.png',
    'white_hatchback_car.png',
    'white_hothatch.png',
    'white_innova.png',
    'white_minivan.png',
    'white_sports_car.png',
    'white_sunroof_car.png',
    'white_suv.png',
    'white_trailer.png',
    'yellow_cab.png',
    'yellow_puller.png',
    'yellow_trailer'
];

export const mapIcons = [
    'ambulance.png',
    'cab_white.png',
    'cargo_van_blue.png',
    'cargo_van_brown.png',
    'cargo_van_deeporange.png',
    'cargo_van_green.png',
    'cargo_van_purple.png',
    'cargo_van_red.png',
    'china_scooter.png',
    'compact_sedan_black.png',
    'compact_sedan_blue.png',
    'compact_sedan_green.png',
    'compact_sedan_purple.png',
    'compact_sedan_red.png',
    'compact_sedan_teal.png',
    'compact_sedan_violate.png',
    'compact_sedan_yellow.png',
    'container_truck_blue.png',
    'container_truck_brown.png',
    'container_truck_green.png',
    'container_truck_rainbow1.png',
    'cycle_gents.png',
    'cycle_gents_red.png',
    'cycle_kids.png',
    'cycle_ladies.png',
    'cycle_sports.png',
    'forklift_blue.png',
    'forklift_brown.png',
    'forklift_green.png',
    'forklift_purple.png',
    'forklift_yellow.png',
    'green_tanker.png',
    'hatchback_blue.png',
    'hatchback_brown.png',
    'hatchback_green.png',
    'hatchback_orange.png',
    'hatchback_pink.png',
    'hatchback_purple.png',
    'hatchback_violate.png',
    'hatchback_white.png',
    'hatchback_yellow.png',
    'innova_blue.png',
    'innova_green.png',
    'innova_orange.png',
    'innova_purple.png',
    'innova_white.png',
    'innova_yellow.png',
    'large_sedan-white.png',
    'minivan_white.png',
    'moped_blue.png',
    'moped_deepred.png',
    'moped_green.png',
    'moped_lightblue.png',
    'moped_lightgreen.png',
    'moped_red.png',
    'moped_violette.png',
    'moped_yellow.png',
    'pickup_truck_blue.png',
    'pickup_truck_deepgreen.png',
    'pickup_truck_deeppurple.png',
    'pickup_truck_deepred.png',
    'pickup_truck_light_green.png',
    'pickup_truck_pink.png',
    'pickup_truck_purple.png',
    'pickup_truck_red.png',
    'pickup_truck_violate.png',
    'pickup_truck_white.png',
    'pickup_truck_yellow.png',
    'police_black.png',
    'police_blue.png',
    'puller_blue.png',
    'puller_brown.png',
    'puller_deepgreen.png',
    'puller_green.png',
    'puller_limegreen.png',
    'puller_pink.png',
    'puller_purple.png',
    'puller_yellow.png',
    'scooter_blue.png',
    'scooter_green.png',
    'scooter_pink.png',
    'scooter_purple.png',
    'scooter_red.png',
    'scooter_violette.png',
    'scooter_yellow.png',
    'scooty_blue.png',
    'scooty_green.png',
    'scooty_purple.png',
    'scooty_red.png',
    'scooty_teal.png',
    'scooty_violette.png',
    'sports_car_blue.png',
    'sports_car_green.png',
    'sports_car_pink.png',
    'sports_car_purple.png',
    'sports_car_red.png',
    'sports_car_white.png',
    'superbike_blue.png',
    'superbike_brown.png',
    'superbike_green.png',
    'superbike_purple.png',
    'superbike_red.png',
    'superbike_violette.png',
    'superbike_yellow.png',
    'tanker_blue.png',
    'tanker_brown.png',
    'tanker_pink.png',
    'taxi_white.png',
    'taxi_yellow.png',
    'vip_car_black.png',
];

export const mapIconsAll = [
    'ambulance.png',
    'cab_white.png',
    'cargo_van_blue.png',
    'cargo_van_brown.png',
    'cargo_van_deeporange.png',
    'cargo_van_green.png',
    'cargo_van_purple.png',
    'cargo_van_red.png',
    'china_scooter.png',
    'compact_sedan_black.png',
    'compact_sedan_blue.png',
    'compact_sedan_green.png',
    'compact_sedan_purple.png',
    'compact_sedan_red.png',
    'compact_sedan_teal.png',
    'compact_sedan_violate.png',
    'compact_sedan_yellow.png',
    'container_truck_blue.png',
    'container_truck_brown.png',
    'container_truck_green.png',
    'container_truck_rainbow1.png',
    'cycle_gents.png',
    'cycle_gents_red.png',
    'cycle_kids.png',
    'cycle_ladies.png',
    'cycle_sports.png',
    'forklift_blue.png',
    'forklift_brown.png',
    'forklift_green.png',
    'forklift_purple.png',
    'forklift_yellow.png',
    'green_tanker.png',
    'hatchback_blue.png',
    'hatchback_brown.png',
    'hatchback_green.png',
    'hatchback_orange.png',
    'hatchback_pink.png',
    'hatchback_purple.png',
    'hatchback_violate.png',
    'hatchback_white.png',
    'hatchback_yellow.png',
    'innova_blue.png',
    'innova_green.png',
    'innova_orange.png',
    'innova_purple.png',
    'innova_white.png',
    'innova_yellow.png',
    'large_sedan-white.png',
    'minivan_white.png',
    'moped_blue.png',
    'moped_deepred.png',
    'moped_green.png',
    'moped_lightblue.png',
    'moped_lightgreen.png',
    'moped_red.png',
    'moped_violette.png',
    'moped_yellow.png',
    'pickup_truck_blue.png',
    'pickup_truck_deepgreen.png',
    'pickup_truck_deeppurple.png',
    'pickup_truck_deepred.png',
    'pickup_truck_light_green.png',
    'pickup_truck_pink.png',
    'pickup_truck_purple.png',
    'pickup_truck_red.png',
    'pickup_truck_violate.png',
    'pickup_truck_white.png',
    'pickup_truck_yellow.png',
    'police_black.png',
    'police_blue.png',
    'puller_blue.png',
    'puller_brown.png',
    'puller_deepgreen.png',
    'puller_green.png',
    'puller_limegreen.png',
    'puller_pink.png',
    'puller_purple.png',
    'puller_yellow.png',
    'scooter_blue.png',
    'scooter_green.png',
    'scooter_pink.png',
    'scooter_purple.png',
    'scooter_red.png',
    'scooter_violette.png',
    'scooter_yellow.png',
    'scooty_blue.png',
    'scooty_green.png',
    'scooty_purple.png',
    'scooty_red.png',
    'scooty_teal.png',
    'scooty_violette.png',
    'sports_car_blue.png',
    'sports_car_green.png',
    'sports_car_pink.png',
    'sports_car_purple.png',
    'sports_car_red.png',
    'sports_car_white.png',
    'superbike_blue.png',
    'superbike_brown.png',
    'superbike_green.png',
    'superbike_purple.png',
    'superbike_red.png',
    'superbike_violette.png',
    'superbike_yellow.png',
    'tanker_blue.png',
    'tanker_brown.png',
    'tanker_pink.png',
    'taxi_white.png',
    'taxi_yellow.png',
    'vip_car_black.png',
    'bulldozer_blue.png',
    'bulldozer_brown.png',
    'bulldozer_green.png',
    'bulldozer_pink.png',
    'bulldozer_yellow.png',
    'crane_green.png',
    'crane_red.png',
    'crane_yellow.png',
    'dumper_blue.png',
    'dumper_green.png',
    'dumper_pink.png',
    'dumper_yellow.png',
    'dumptruck_blue.png',
    'dumptruck_green.png',
    'dumptruck_red.png',
    'dumptruck_yellow.png',
    'poclain_blue.png',
    'poclain_green.png',
    'poclain_pink.png',
    'poclain_yellow.png',
    'jcb_cyan.png',
    'jcb_green.png',
    'jcb_pink.png',
    'jcb_yellow.png',
    'manlift_blue.png',
    'manlift_green.png',
    'manlift_purple.png',
    'manlift_red.png',
    'manlift_yellow.png',

];